export default {
  label: 'Operation',
  items: {
    sum: 'Sum',
    count: 'Count',
    avg: 'Average',
    min: 'Minimum',
    max: 'Maximum',
    first: 'First',
    last: 'Last',
    size: 'Document count',
  },
};
